import { Link } from "@tanstack/react-router";
import { useState, useEffect } from "react";
import { NAV, SITE } from "@/lib/site";
import { SiteSearch } from "@/components/SiteSearch";

function DollarTicker() {
  const [rate, setRate] = useState<number | null>(null);

  useEffect(() => {
    fetch("https://economia.awesomeapi.com.br/last/USD-BRL")
      .then(res => res.json())
      .then(data => {
        if (data.USDBRL) {
          setRate(parseFloat(data.USDBRL.bid));
        }
      })
      .catch(err => console.error("Erro ao buscar dólar:", err));
  }, []);

  if (!rate) return null;

  return (
    <div className="bg-foreground text-background py-1 text-[11px] font-bold uppercase tracking-wider overflow-hidden whitespace-nowrap">
      <div className="container-svg flex items-center justify-center gap-2">
        <span className="opacity-70">Cotação do Dólar hoje:</span>
        <span className="text-primary-foreground font-display text-xs">R$ {rate.toFixed(2).replace('.', ',')}</span>
      </div>
    </div>
  );
}


export function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/95 backdrop-blur-xl">
      <DollarTicker />

      <div className="container-svg flex h-[72px] items-center justify-between gap-4">
        <Link to="/" className="group flex items-center gap-2.5" aria-label={`${SITE.name} — Início`}>
          <span aria-hidden className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-foreground font-bold text-background text-sm leading-none tracking-tighter">LV</span>
          <span className="flex flex-col leading-none">
            <span className="font-display text-lg md:text-xl font-bold tracking-tight text-foreground">Liderança com Valores</span>
            <span className="text-[10px] uppercase tracking-[0.2em] text-muted-foreground mt-1">Conteúdo para líderes</span>
          </span>
        </Link>
        <nav className="hidden items-center gap-0.5 lg:flex" aria-label="Principal">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              activeOptions={n.to === "/" ? { exact: true } : undefined}
              activeProps={{ className: "text-primary-foreground bg-primary" }}
              inactiveProps={{ className: "text-foreground hover:bg-secondary" }}
              className="whitespace-nowrap rounded-md px-3 py-1.5 text-[13px] font-semibold leading-none transition-all"
            >
              {n.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <Link to="/blog" className="hidden md:inline-flex btn-accent px-4 py-2 text-xs">Ler artigos</Link>
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            className="lg:hidden inline-flex h-11 w-11 items-center justify-center rounded-md border border-border bg-background text-foreground"
            aria-label="Abrir menu"
            aria-expanded={open}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
              {open ? <path d="M6 6l12 12M6 18L18 6" /> : <><path d="M4 7h16" /><path d="M4 12h16" /><path d="M4 17h16" /></>}
            </svg>
          </button>
        </div>
      </div>
      <div className="hidden md:block border-t border-border bg-secondary/40">
        <div className="container-svg py-2 flex justify-center">
          <div className="w-full max-w-2xl">
            <SiteSearch compact />
          </div>
        </div>
      </div>
      {open && (
        <div className="lg:hidden border-t border-border bg-background">
          <nav className="container-svg flex flex-col py-3" aria-label="Menu mobile">
            <div className="mb-2"><SiteSearch compact /></div>
            {NAV.map((n) => (
              <Link
                key={n.to}
                to={n.to}
                onClick={() => setOpen(false)}
                activeOptions={{ exact: n.to === "/" }}
                activeProps={{ className: "text-primary-foreground bg-primary" }}
                inactiveProps={{ className: "text-foreground hover:bg-secondary" }}
                className="rounded-md px-3 py-3 text-sm font-semibold transition-colors"
              >
                {n.label}
              </Link>
            ))}
            <Link to="/blog" onClick={() => setOpen(false)} className="btn-accent mt-3 w-full">Ler artigos</Link>
          </nav>
        </div>
      )}
    </header>
  );
}
